// How long upload success popups stay open, kept the same across every upload entry point
// so the result is readable before the popup auto-closes.
const UPLOAD_SUCCESS_DURATION_MS = 5000;

export default UPLOAD_SUCCESS_DURATION_MS;
